import React, { useMemo } from "react";
import { LDS_AUTOCMPLETE_CITIES } from "../../../assets/Data/LdsAirportsAutocomplete";
import {
  contextDateToIso,
  submitFlightSearchFromScreen,
} from "../bridge/liveStageModels";
import { countFlightPassengersFromRoomInfo } from "../../../Components/FlightBookingFlowMockup/adapters/flightOfferAdapter";
import { useSearch } from "../../../contexts/SearchContext";
import FlightSearchScreen from "./FlightSearchScreen";

function findLdsAirport(code) {
  const needle = String(code || "").trim().toUpperCase();
  if (!needle) return null;
  return (
    LDS_AUTOCMPLETE_CITIES.find(
      (city) => String(city?.AIRPORTCODE || "").trim().toUpperCase() === needle
    ) || null
  );
}

/**
 * Thin live host. FlightSearchScreen is the preview component.
 * Submit writes the existing search fields and calls submitSearch.
 */
export default function FlightSearchLive() {
  const search = useSearch();
  const initialSearch = useMemo(() => {
    const originCode = String(
      search.origin?.AIRPORTCODE || search.origin?.iata || ""
    ).toUpperCase();
    const destCode = String(
      search.location?.AIRPORTCODE || search.location?.iata || ""
    ).toUpperCase();
    const oneWay = String(search.flightTripType || "") === "OneWay";
    const cabinRaw = search.cabin ?? search.flightCabin;
    const cabin =
      typeof cabinRaw === "string" && cabinRaw.trim() ? cabinRaw.trim() : "";
    return {
      origin: originCode,
      destination: destCode,
      tripType: oneWay ? "oneway" : "roundtrip",
      departDate: contextDateToIso(search.calendarDateArrival),
      returnDate: oneWay ? "" : contextDateToIso(search.calendarDateLeave),
      passengers: {
        adults: countFlightPassengersFromRoomInfo(search.roomInfo) || 1,
      },
      cabin,
    };
  }, [
    search.origin,
    search.location,
    search.flightTripType,
    search.calendarDateArrival,
    search.calendarDateLeave,
    search.roomInfo,
    search.cabin,
    search.flightCabin,
  ]);

  return (
    <FlightSearchScreen
      key={[
        initialSearch.origin,
        initialSearch.destination,
        initialSearch.departDate,
        initialSearch.returnDate,
        initialSearch.tripType,
      ].join("|")}
      initialSearch={initialSearch}
      onSearch={(form) => {
        submitFlightSearchFromScreen({
          form,
          current: search,
          findAirport: findLdsAirport,
          setOrigin: search.setOrigin,
          setLocation: search.setLocation,
          setFlightTripType: search.setFlightTripType,
          setCalendarDateArrival: search.setCalendarDateArrival,
          setCalendarDateLeave: search.setCalendarDateLeave,
          submitSearch: search.submitSearch,
        });
      }}
    />
  );
}
